/** Route Constants */
export const RouteConstants = {
  ROUTE_ACCESS: {
    REQUIRES_LOGIN: 'SECURE',
    REQUIRES_NO_LOGIN: 'PUBLIC',
    ALL: 'ALL',
  },
};
